import type { ReactNode } from 'react';
import { classes } from '../layout/space';
import './PreviewPill.css';

type Props = {
  icon: ReactNode;
  children: ReactNode;
  className?: string;
} & ({ onClick: () => void; disabled?: boolean } | { onClick?: never; disabled?: never });

/** Shared preview action/status appearance; only actions render as buttons. */
export function PreviewPill({ icon, children, className, onClick, disabled }: Props) {
  const content = <>{icon}<span>{children}</span></>;
  const styleClass = classes('preview-pill', className);
  return onClick ? (
    <button type="button" className={styleClass} onClick={onClick} disabled={disabled}>{content}</button>
  ) : (
    <span className={styleClass} role="status">{content}</span>
  );
}
